import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
    alertModalContent: null,
};

const alertModalSlice = createSlice({
    name: 'alertModalData',
    initialState,
    reducers: {
        setModalContent(state, action) {
            state.alertModalContent = action.payload;
        },
        resetModalContent() {
            return { ...initialState };
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setModalContent, resetModalContent } = alertModalSlice.actions;
export default alertModalSlice.reducer;
